import {
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import IconBox from "components/icons/IconBox";
import { IconArrowDown } from "components/icons/Icons";

interface ManagerCellProps {
  managers: any[];
  allManagers: any[];
  onAssignManager: (documentId: string, manager: any) => void;
  onClickView: (manager: any) => void;
  documentId: string;
}

export function ManagerCell({
  managers,
  allManagers,
  onAssignManager,
  onClickView,
  documentId,
}: ManagerCellProps) {
  const shadow = useColorModeValue(
    "0px 4px 50px rgba(0, 0, 0, 0.1)",
    "0px 4px 50px rgba(0, 0, 0, 0.1)"
  );

  return (
    <Flex alignItems="center">
      <Menu>
        <MenuButton
          padding={"10px 10px 10px 15px"}
          backgroundColor="#FFF"
          borderRadius="100px"
          border="1px solid #E9E9E9"
        >
          <Flex alignItems={"center"}>
            <Text
              fontSize={"14px"}
              lineHeight="24px"
              fontWeight={"400"}
              color="black"
              maxW="100px"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              overflow="hidden"
            >
              {managers?.length > 0
                ? `${managers[0]?.first_name} ${managers[0]?.last_name}`
                : "Not Assigned"}
            </Text>
            <IconBox
              marginLeft="10px"
              icon={<IconArrowDown width="24px" height="24px" />}
            />
          </Flex>
        </MenuButton>
        <MenuList
          width="195px"
          minWidth="195px"
          boxShadow={shadow}
          p="0px"
          mt="10px"
          borderRadius="20px"
          bg={"#FFF"}
          border="none"
        >
          <Flex
            flexDirection="column"
            p="10px 20px"
            fontSize={"14px"}
            lineHeight="24px"
            fontWeight={"400"}
            color="black"
          >
            {allManagers.map((option: any, index: number) => (
              <MenuItem
                key={index}
                _hover={{ bg: "none" }}
                _focus={{ bg: "none" }}
                borderRadius="8px"
                padding="10px 0px"
                borderBottom={
                  index < allManagers.length - 1 ? "1px solid #F3F5F5" : ""
                }
                onClick={() => onAssignManager(documentId, option)}
              >
                <Text fontSize="sm">
                  {`${option?.first_name ?? ""} ${option?.last_name ?? ""}`}
                </Text>
                <Button
                  padding="5px 10px"
                  borderRadius="100px"
                  bgColor="#F3F5F5"
                  fontSize={"14px"}
                  lineHeight="24px"
                  fontWeight={"400"}
                  marginLeft="auto"
                  onClick={(e) => {
                    onClickView(option);
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                >
                  View
                </Button>
              </MenuItem>
            ))}
          </Flex>
        </MenuList>
      </Menu>
    </Flex>
  );
}
